<template>
  <div
    amn="amin"
    class="q-card"
    :class="shadow ? 'is-' + shadow + '-shadow' : 'is-always-shadow'"
  >
    <div
      v-if="$slots.header || header"
      class="q-card__header"
    >
      <slot name="header">
        {{ header }}
      </slot>
    </div>
    <div
      class="q-card__body"
      :style="bodyStyle"
    >
      amin
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'QCard',
    props: {
      header: {},
      bodyStyle: {},
      shadow: {
        type: String
      }
    }
  };
</script>
